<script setup>
/**
 * "No WhatsApp number is wired for sending here" — ONE component, because it was three.
 *
 * The BFF answers 403 `outbound_not_provisioned` on every outbound read when a workspace
 * has no sender connected. That is a STATE, and the ordinary state of a workspace on its
 * first day: nothing is broken, nothing was lost, and retrying cannot connect a number.
 * So it gets no ruby triangle and no "Try again", exactly like `WasloPageLayout`'s own
 * `not-provisioned` branch — which is the sibling fact one layer up (that one means the
 * account has no assistant at all) and is deliberately the shape this copies.
 *
 * WHY IT IS A COMPONENT AND NOT THREE BLOCKS OF MARKUP. Setup, the Message log and one
 * message each rendered this independently: Setup as a left-aligned card inside its body,
 * the other two as centred empty states with different icons. Same fact about the same
 * workspace, told three ways, drifting the moment any one of them was edited. The three
 * pages now render this and cannot disagree; `specs/outbound.spec.js` asserts they don't.
 */
import { useWasloI18n } from '../../i18n.js';

const { t } = useWasloI18n();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-3 py-16 text-center"
    data-waslo-outbound-not-set-up
  >
    <span class="size-6 i-lucide-plug text-n-slate-10" aria-hidden="true" />
    <span class="text-base font-medium text-n-slate-12">
      {{ t('WASLO.OUTBOUND.COMMON.NOT_SET_UP_TITLE') }}
    </span>
    <p class="max-w-md mb-0 text-sm leading-6 text-n-slate-11">
      {{ t('WASLO.OUTBOUND.COMMON.NOT_SET_UP_BODY') }}
    </p>
  </div>
</template>
